import { CardFooter, Headline } from '@sumup/circuit-ui';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { API } from '../../constants/api.constants';
import { IDoubleOfferForm } from '../../interfaces/offers.interfaces';
import {
  IDataResponseModel,
  IRequestDuplicarOferta,
  ISubmitError
} from '../../interfaces/requests.interfaces';
import { post } from '../../services/axios.service';
import { doubleOfferValidation } from '../../utils/yup-utils';
import { CustomButton, InputField } from '../_Atoms';
import { StyledActionsBar, StyledContentBox } from './styles';

interface IDoubleOffer {
  OfertaId: number;
  removeModal: () => void;
  getOffers: () => void;
}

const DoubleOffer: React.FC<IDoubleOffer> = ({
  OfertaId,
  removeModal,
  getOffers
}) => {
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState<ISubmitError>({
    showError: false,
    message: ''
  });

  const handleSubmit = async (formValues: IDoubleOfferForm) => {
    setLoading(true);
    setSubmitError({ showError: false, message: '' });
    const formatedData: IRequestDuplicarOferta = {
      id: OfertaId,
      nome: formValues.name
    };
    try {
      const res = await (
        await post
      )<IDataResponseModel<{ id: number; nome: string }>>(
        API.OFERTAS.DUPLICAR,
        formatedData
      );

      if (res.success) {
        getOffers();
        removeModal();
      }

      if (res.error) {
        setSubmitError({
          showError: true,
          message: res.message
        });
      }
    } catch (err) {
      setSubmitError({
        showError: true,
        message:
          'Houve um problema com a requisição. Por favor, tente novamente'
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Headline size="three" as="h3">
        Duplicar oferta
      </Headline>
      <Formik
        initialValues={{ name: '' }}
        onSubmit={(formValues) => handleSubmit(formValues)}
        validationSchema={doubleOfferValidation}
        validateOnMount
      >
        {({ handleChange, handleBlur, errors, touched, isValid }) => (
          <Form>
            <StyledActionsBar>
              <StyledContentBox>
                <InputField
                  errorMessage={
                    errors.name != null ? errors.name : submitError.message
                  }
                  label="Insira um novo nome para a oferta duplicada:"
                  placeholder="Nome da oferta duplicada"
                  id="double-offer-name"
                  invalid={
                    !!(errors.name && touched.name) || submitError.showError
                  }
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="text"
                />
              </StyledContentBox>
            </StyledActionsBar>
            <CardFooter align="right">
              <CustomButton
                variant="secondary"
                type="button"
                stretch
                onClick={removeModal}
              >
                Cancelar
              </CustomButton>
              <CustomButton
                isLoading={loading}
                disabled={!isValid}
                loadingLabel="Salvando..."
                variant="primary"
                type="submit"
                stretch
              >
                Salvar
              </CustomButton>
            </CardFooter>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default DoubleOffer;
